/**
 * Contact-related strings.
 */
import React from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import Icons from '../ui/IconButton/Icons';

export default {
    d_name: 'Name',
    h_name: <div>
        <p>If <FontAwesomeIcon icon={Icons.UNCHECKED.reactIcon}/> <b>Is Company</b> is not checked, this will
        be the full legal name of the person.</p>
        <p>Outlaw Practice provides a number of fields to encapsulate a person's name.</p>
        <p>Names in Outlaw Practice are sometime given as Last, First Middle, and sometimes First Middle Last,
        depending on what formatting makes finding or formatting contact names more useful.</p>
        <p>Here are the fields:</p>
        <ul>
            <li><b>Title</b> - If the user has a title, like Dr. or Prof.</li>
            <li><b>First</b> - The contact's legal first name.</li>
            <li><b>Middle</b> - The contact's middle name(s). If there are multiple middle names, put them in order here.</li>
            <li><b>Last</b> - The contact's last name(s).  You can use hyphenated last name, or even multiple last names
            with spaces.</li>
            <li><b>Suffix</b> - If the contact uses a suffix, suck as Jr. or Sr., put it here.  This is also a place to
            put credentials, such as Esquire or M.D.</li>
            <li><b>Nickname</b> - If the contact prefers a nickname to their first name, put that name here. Often
            this is the person's middle name, or a variant of the first name, e.g. Jack instead of John.  Outlaw Practice
            will prefer the nickname to the first name in all displays.</li>
        </ul>
    </div>,

    d_businessName: 'Name',
    h_businessName: <div>
        <p>If <FontAwesomeIcon icon={Icons.CHECKED.reactIcon}/> <b>Is Company</b> is checked, this will be the full name of
            the business.</p>
    </div>,

    d_aliases: 'Aliases',
    h_aliases: '<div><p>If the person has aliases that they go by, put them here.  These will be included in conflict checks.</p></div>',

    d_billingName: 'Billing Name',
    h_billingName: '<div><p>If the contact has a preferred name they would like to appear on their bills, enter that here.  It will be used on all invoices.</p></div>',

    d_company: 'Company',
    h_company: 'What company does the contact work for?',

    d_jobTitle: 'Job Title',
    h_jobTitle: '<div><p>If the contact has a job title or role, you can put it here.</p><p>Examples include "Supervisor", "Attorney" or "Officer".</p></div>',
};